import { DockForFtlRouteViewModel } from "../../../../ViewModel/DockForFtlRouteViewModel";
import { EditProjectContextProps } from "../../../EditProjectContext";

export const addDockToRoute = (
  ftlRouteId: number,
  items: Array<DockForFtlRouteViewModel>,
  EditProjectContext: EditProjectContextProps
) => {
  const { project, setProject } = EditProjectContext;
  const updateFtlRoute = project?.FTLRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteId !== ftlRouteId || !ftlRoute.Docks) {
      return ftlRoute;
    }
    return {
      ...ftlRoute,
      Docks: [...ftlRoute.Docks, ...items],
    };
  });

  setProject({
    ...project,
    FTLRoutes: updateFtlRoute,
  });
};
